import { useCallback, useRef, useEffect, useState } from "react";

const mobileMediaQuery = "screen and (max-width: 1136px)";

export function useMobile() {
	if (typeof window === 'undefined') return false;
	
	const mql = useRef(window.matchMedia(mobileMediaQuery));
	const [mobile, setMobile] = useState(mql.current.matches);

	const handleMediaQueryChange = useCallback((query) => {
		setMobile(query.matches);
	}, []);

	useEffect(() => {
		const query = mql.current;

		query.addEventListener("change", handleMediaQueryChange);
		return () => {
			query.removeEventListener("change", handleMediaQueryChange);
		};
	}, [handleMediaQueryChange]);

	return mobile;
}